var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.13086 11.5178H12.0039C13.1289 11.5178 13.791 10.8616 13.791 9.60767V3.43188C13.791 2.17798 13.1289 1.52173 11.8633 1.52173H6.35547C5.93359 1.52173 5.68164 1.42212 5.35352 1.15259L5.01953 0.883057C4.60938 0.549072 4.30469 0.431885 3.68945 0.431885H1.95508C0.853516 0.431885 0.203125 1.07642 0.203125 2.31274V9.60767C0.203125 10.8616 0.865234 11.5178 2.13086 11.5178ZM1.36914 2.41821C1.36914 1.87915 1.66797 1.5979 2.18945 1.5979H3.37891C3.79492 1.5979 4.04102 1.69751 4.36914 1.96704L4.70312 2.24243C5.11328 2.57056 5.42969 2.68774 6.04492 2.68774H11.7871C12.3203 2.68774 12.6191 2.96899 12.6191 3.53149V3.88892H1.36914V2.41821ZM2.20703 10.3518C1.66797 10.3518 1.36914 10.0706 1.36914 9.5022V4.91431H12.6191V9.50806C12.6191 10.0706 12.3203 10.3518 11.7871 10.3518H2.20703Z",
    fill: "#BFBBCF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocument);
export default __webpack_public_path__ + "static/media/icon-document.02fff5ff0a6e72d1f33d181e4f11634a.svg";
export { ForwardRef as ReactComponent };